var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportFillterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1693",
    "data-name": "Group 1693",
    transform: "translate(-0.187 -0.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 16,
    height: 16,
    transform: "translate(0.187 0.385)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M15.709,3H2L7.484,9.892v4.764l2.742,1.457V9.892Z",
    transform: "translate(-0.753 -1.279)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFillterIcon);
export default __webpack_public_path__ + "static/media/report-fillter-icon.f242b7053f4835b041f5c3911f1e7fee.svg";
export { ForwardRef as ReactComponent };